import { getAuthHeaders } from "@/shared/api/authHeaders";
import { keysToSnakeCase } from "@/shared/lib/case";
// This file is generated by generate-entities.ts. Please DO NOT edit this file directly.
import type { QueryOptions } from "@/shared/lib/tanstack-query";
import {
  type UseQueryResult,
  useQueries,
  useQuery,
} from "@tanstack/react-query";
import { FreightMatching } from "@x-mile/api-contract";
import type { GetAccountRequestsParams } from "../model";

export const useGetAccountRequests = (
  params: GetAccountRequestsParams,
  options?: QueryOptions<typeof FreightMatching.useGetAccountRequests>,
): UseQueryResult<FreightMatching.GetAccountRequestsQueryResult, undefined> => {
  const authHeaders = getAuthHeaders();
  const result = useQuery({
    ...options,
    queryKey: ["getAccountRequests", keysToSnakeCase(params)],
    queryFn: () =>
      FreightMatching.getAccountRequests(
        // バックエンド（rails）ではキーがスネークケースになっているため、クエリパラメータをスネークケースに変換する
        keysToSnakeCase(params),
        {
          headers: authHeaders.isOk() ? authHeaders.value : {},
        },
      ),
  });
  return result as UseQueryResult<
    FreightMatching.GetAccountRequestsQueryResult,
    undefined
  >;
};

export const useMultipleGetAccountRequests = (
  paramsList: { [key: string | number]: GetAccountRequestsParams },
  options?: QueryOptions<typeof FreightMatching.useGetAccountRequests> & {
    sortFunc?: (
      a: GetAccountRequestsParams,
      b: GetAccountRequestsParams,
    ) => number;
  },
): {
  [key: string | number]: UseQueryResult<
    FreightMatching.GetAccountRequestsQueryResult,
    undefined
  >;
} => {
  const authHeaders = getAuthHeaders();
  const keys = Object.keys(paramsList);
  const sortedKeys = options?.sortFunc
    ? keys.sort((a, b) =>
        options?.sortFunc ? options.sortFunc(paramsList[a], paramsList[b]) : 0,
      )
    : keys;
  const result = useQueries({
    queries: sortedKeys.map((key) => {
      const params = paramsList[key];
      return {
        ...options,
        queryKey: ["getAccountRequests", keysToSnakeCase(params)],
        queryFn: () =>
          FreightMatching.getAccountRequests(
            // バックエンド（rails）ではキーがスネークケースになっているため、クエリパラメータをスネークケースに変換する
            keysToSnakeCase(params),
            {
              headers: authHeaders.isOk() ? authHeaders.value : {},
            },
          ),
      };
    }),
  });
  const resultByKeys = Object.fromEntries(
    keys.map((key, i) => [key, result[i]]),
  );
  return resultByKeys as {
    [key: string | number]: UseQueryResult<
      FreightMatching.GetAccountRequestsQueryResult,
      undefined
    >;
  };
};

// TODO: api-contract側でmockを生成しないことになったので、自前でmockを生成する
// export const useGetAccountRequestsMock = (
//   params: GetAccountRequestsParams,
//   options?: QueryOptions<typeof FreightMatching.useGetAccountRequests>,
// ) => {
//   const [workerStarted, setWorkerStarted] = useState(false);
//   void (async () => {
//     if (!workerStarted) {
//       await FreightMatching.startMockServerWoker(
//         FreightMatching.getGetAccountRequestsMockHandler(),
//       );
//       setWorkerStarted(true);
//     }
//   })();
//   return useGetAccountRequests(params, {
//     enabled: workerStarted && options?.enabled,
//   });
// };

// export const useMultipleGetAccountRequestsMock = (
//   paramsList: { [key: string | number]: GetAccountRequestsParams },
//   options?: QueryOptions<typeof FreightMatching.useGetAccountRequests>,
// ) => {
//   const [workerStarted, setWorkerStarted] = useState(false);
//   void (async () => {
//     if (!workerStarted) {
//       await FreightMatching.startMockServerWoker(
//         FreightMatching.getGetAccountRequestsMockHandler(),
//       );
//       setWorkerStarted(true);
//     }
//   })();
//   return useMultipleGetAccountRequests(paramsList, {
//     enabled: workerStarted && options?.enabled,
//   });
// };
